import Checkbox from "../components/Checkbox";
import WhiteBox from "../components/WhiteBox";
import { Navigator, useStepper } from "../Stepper";
import styled from "styled-components";
import { useState } from "react";
import Heading from "components/Heading";

const OPTIONS = [
  {
    id: "collection",
    label: "Cuentas en Colección",
  },
  {
    id: "late-payments",
    label: "Pagos Atrasados",
  },
  {
    id: "medical",
    label: "Cuentas Médicas",
  },
  {
    id: "student-loan",
    label: "Loan Estudiantiles",
  },
  {
    id: "inquiries",
    label: "Indagaciones",
  },
  {
    id: "bankruptcy",
    label: "Bancarrota",
  },
  {
    id: "new-credit",
    label: "Crédito Nuevo",
  },
  {
    id: "others",
    label: "Otros",
  },
];

const CurrentProblemsWrapper = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  padding: 30px 0;
  max-width: 100%;
  list-style: none;
`;

const CurrentProblems = () => {
  const { getDefault } = useStepper();
  const [selectedOptions, setSelectedOptions] = useState(
    getDefault("currentProblems") || []
  );
  const canContinue = selectedOptions.length > 0;

  return (
    <>
      <Heading
        title={`¿Qué está afectando su crédito?`}
        body={`Establezcamos una estrategia basada en los detalles negativos que
        estén afectando su crédito.`}
      />

      <CurrentProblemsWrapper>
        {OPTIONS.map(({ id, label }) => (
          <li key={id}>
            <WhiteBox>
              <Checkbox
                id={`option-${id}`}
                value={id}
                checked={selectedOptions.includes(id)}
                onChange={() => {
                  if (selectedOptions.includes(id)) {
                    setSelectedOptions(
                      selectedOptions.filter((op) => op !== id)
                    );
                  } else {
                    setSelectedOptions([...selectedOptions, id]);
                  }
                }}
              >
                {label}
              </Checkbox>
            </WhiteBox>
          </li>
        ))}
      </CurrentProblemsWrapper>

      <Navigator
        saveDataHandler={() => selectedOptions}
        $disableContinue={!canContinue}
      />
    </>
  );
};

export default CurrentProblems;
